import { http } from '../request'
import type { PaginationData } from '../request'
import type {
    GameSkin,
    GameSkinCreateRequest,
    GameSkinUpdateRequest,
    GameSkinCreateResponse,
    GameSkinUpdateResponse
} from '../types/skins'

/**
 * 游戏皮肤相关 API
 */
export const skinsApi = {
    /**
     * 获取所有皮肤数据（分页格式）
     * GET /api/skins/
     */
    getAllSkins(params?: { page?: number; size?: number }): Promise<PaginationData<GameSkin>> {
        return http.get<PaginationData<GameSkin>>('/api/skins/', { params })
    },

    /**
     * 创建皮肤
     * POST /api/skins/
     */
    createSkin(data: GameSkinCreateRequest): Promise<GameSkinCreateResponse> {
        return http.post<GameSkinCreateResponse>('/api/skins/', data)
    },

    /**
     * 更新皮肤
     * PUT /api/skins/{id}/
     */
    updateSkin(id: number, data: GameSkinUpdateRequest): Promise<GameSkinUpdateResponse> {
        return http.put<GameSkinUpdateResponse>(`/api/skins/${id}/`, data)
    },

    /**
     * 删除皮肤
     * DELETE /api/skins/{id}/
     */
    deleteSkin(id: number): Promise<void> {
        return http.delete<void>(`/api/skins/${id}/`)
    }
}

export default skinsApi 